var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"base-check-type-1"},_vm.inputListeners),[_c('div',{staticClass:"check-box"},[(_vm.value)?_c('i',{staticClass:"material-icons icon"},[_vm._v("check")]):_vm._e()]),_vm._v("\n  "+_vm._s(_vm.propLabel)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }